import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/client';
import { API_BASE_URL } from '../../config/api';
import homeFeatureVideo from '../../assets/videos/home-feature.mp4';

const FALLBACK_STORY = {
  tag: 'Featured Story',
  title: 'Healthy food, made with care every day',
  description:
    'Take a quick look at the Digirasa kitchen experience and the quality we deliver to your doorstep.',
  points: [
    'Hygienic kitchen process',
    'Balanced daily meal options',
    'Reliable doorstep delivery',
  ],
  cta_text: 'Explore Menu',
  cta_link: '/our-menu',
  media_type: 'video',
  absolute_media_url: homeFeatureVideo,
};

const HomeFeaturedStory = () => {
  const [story, setStory] = useState(FALLBACK_STORY);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`${API_BASE_URL}/api/web-featured-stories/active`);
        const rows = Array.isArray(data?.data) ? data.data : [];
        if (!cancelled && rows[0]) setStory(rows[0]);
      } catch {
        /* keep fallback */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!story) return null;

  return (
    <section className="home-feature-media">
      <div className="container">
        <div className="home-feature-media__card">
          <div className="home-feature-media__layout">
            <div className="home-feature-media__video-wrap">
              {story.media_type === 'image' ? (
                <img
                  className="home-feature-media__video"
                  src={story.absolute_media_url}
                  alt={story.title}
                />
              ) : (
                <video
                  className="home-feature-media__video"
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls
                  preload="metadata"
                  src={story.absolute_media_url}
                >
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
            <div className="home-feature-media__content">
              {story.tag ? <span className="home-feature-media__tag">{story.tag}</span> : null}
              <h2>{story.title}</h2>
              {story.description ? <p>{story.description}</p> : null}
              {Array.isArray(story.points) && story.points.length ? (
                <ul className="home-feature-media__points">
                  {story.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              ) : null}
              {story.cta_text && story.cta_link ? (
                <Link to={story.cta_link} className="btn-primary">
                  {story.cta_text}
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFeaturedStory;
